/*
 * Built with Common Launchpad 2.0.3
 */

import FormTools from '../utils/formTools';

window.FormTools = new FormTools();

$(() => {
	window.FormTools.init();
});